import {
  Button,
  Grid,
  makeStyles,
  Card
} from "@material-ui/core";
//import moment from "moment";
import "moment/locale/es";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bajaPracticaPrestadorRestringido, buscarPracticasPrestadoresRestringidos, fetchPracticasPrestadoresRestringidos } from "../../../../actions/autorizaciones/abmPrestadoresRestringidos";
import BuscadorAbm from "../../../compartidos/abms/BuscadorAbm";
import TableGeneric from "../../../compartidos/abms/TableGeneric";
import AccionesGenericoAbm from "../../../compartidos/abms/AccionesGenericoAbm";
import { TIPOS_DOCUMENTACION_PRACTICA_SOLICITUD } from "../../../../utils/permisos";
import AlertDialogSlide from "../../../ui/AlertaConfirm";

const useStyles = makeStyles((theme) => ({
  chip: {
    margin: theme.spacing(0.5),
  },
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.5),
    margin: 0,
  },
}));

export const FormVerPrestExternosPracticas = (props) => {

  const { idEfectorFacturacion } = props;
    const [mostrarMsjDelete, setMostrarMsjDelete] = useState(false);
    const [itemDelete, setItemDelete] = useState(0);
  
    //const [openModalInfo, setOpenModalInfo] = useState(false);
    //const [idClave, setIdClave] = useState(false);
    //const [descripcion, setDescripcion] = useState(false);                             
    const { itemsPracticas = [] } = useSelector((state) => state.prestadoresRestringidos);
  
    const dispatch = useDispatch()
  
    useEffect(() => {
      dispatch(fetchPracticasPrestadoresRestringidos(idEfectorFacturacion));
    }, [dispatch]);
  
    const handleSearch = (textoBuscado) => {
      dispatch(buscarPracticasPrestadoresRestringidos(textoBuscado));
    }
  
    const classes = useStyles()

    const handleDelete = (item) => {
        setItemDelete(item);
        setMostrarMsjDelete(true);

      }
    
      const handleDecision = (decicion) => {
        if (decicion === 'SI'){
          const data = {
            idEfectorFacturacion: itemDelete.idEfectorFacturacion,
            idCodNom: itemDelete.idCodNom,
          }
          dispatch(bajaPracticaPrestadorRestringido(data));
          setMostrarMsjDelete(false);
        } else {
          setMostrarMsjDelete(false);
        }
        setItemDelete(0);
      }

  return (
    <>
    {(mostrarMsjDelete) && <AlertDialogSlide 
        open={alert}
        setOpen={()=>{}}
        handleDecision={handleDecision}
        mensaje={'¿Está seguro que desea eliminar la práctica?'}
    />}
      <Grid container justify="center">
        <Grid item xs={12} md={6} className={classes.root}>
          <BuscadorAbm title="Buscar Prácticas" handleSearch={handleSearch} />
        </Grid>
      </Grid>
      <Grid item xs={12} md={12} style={{ marginTop: "2rem" }} >
          <Card>
            <TableGeneric
              data={itemsPracticas}
              columns={[
                // {
                //   label: "",
                //   id: "",
                //   sort: false,
                //   customBody: (item) => (
                //     <InfoHistorialIcon
                //       onClick={() => {
                //         setOpenModalInfo(true);
                //         setIdClave(item?.id);
                //         setDescripcion(`${item?.codNom} - ${item?.desNom}`);
                //       }}
                //     />
                //   ),
                // },
                {
                  label: "Razon Social",
                  id: "razonSocial",
                  sort: true
                },
                {
                  label: "Codigo Nomenclador",
                  id: "codNom",
                  sort: true
                },
                {
                  label: "Descripción",
                  id: "descripcionNomenclador",
                  sort: true
                },
                {
                  label: "Nivel",
                  id: "nivel",
                  sort: true
                },
                {
                  label:"",
                  customBody:(item) => (
                    <AccionesGenericoAbm
                      item={item}
                      handleItemSelect={null}
                      permisoDelete={TIPOS_DOCUMENTACION_PRACTICA_SOLICITUD.BAJA}
                      handleDelete={handleDelete}
                      showSelect={false}
                      showDelete={true}
                    />
                  )
                }
              ]}
            />
            {/* {openModalInfo && (
              <ModalHistoricoTrackingAbm
                open={openModalInfo}
                onClose={() => setOpenModalInfo(false)}
                idClave={idClave}
                descripcion={descripcion}
                tipoTrackingId={TIPO_TRACKING_ABM.NOMENCLADOR_NACIONAL}
              />
            )} */}
          </Card>
        </Grid>
      
      <div style={{ textAlign: "right", marginTop: "2rem" }}>
        <Button onClick={props.handleCloseModal} type="button" color="primary">
          Cerrar
        </Button>
      </div>
    </>
  )
}
